import { Box, Button, Text } from '@chakra-ui/react'
import { Logo } from 'components/atoms'
import { Error } from 'components/molecules/Error'
import { Link as LinkRouter } from 'react-router-dom'

export const NotFound: React.FC = () => {
    return (
        <Box
            data-testid="page-not-found"
            display="flex"
            alignItems="center"
            justifyContent="center"
            minH="100vh"
        >
            <Error status={404} />
        </Box>
    )
}

export const ValidationPage: React.FC = () => {
    return (
        <Box
            data-testid="page-not-found"
            display="flex"
            alignItems="center"
            justifyContent="center"
            minH="100vh"
        >
            <Box
                data-testid="error-wrapper"
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexDirection="column"
                gap={14}
            >
                <Box>
                    <Logo maxW={187} />
                </Box>
                <Box
                    textAlign="center"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    flexDirection="column"
                    gap={6}
                >
                    <Text color="primary.500" fontWeight="700" fontSize={60}>
                        Documento válido!
                    </Text>

                    {/* <Text
                        whiteSpace="pre"
                        color="black"
                        fontWeight="700"
                        fontSize={36}
                    >
                        {'Documento foi \n validado com sucesso!'}
                    </Text> */}
                </Box>
                <Button
                    data-testid="error-button"
                    as={LinkRouter}
                    to="/"
                    colorScheme="primary"
                    size="md"
                >
                    Voltar para o início
                </Button>
            </Box>
        </Box>
    )
}
